/**
 * Created by Aleksandr on 15.06.2023
 */

const MSStartSocial = function () {
    Social.call(this, connector.MSSTART, {
        sdk: SdkManager.SDK_MSSTART
    });

    this.checkLogin = connector.utils.timeredThrottle(10000, () => this._checkLogin());

    const scheduleCheckLogin = connector.utils.timeredThrottle(30000, () => {
        for (const seconds of [2, 12, 25, 40, 60]) {
            connector.timeouts.setTimeout(() => this.checkLogin(), seconds * 1000);
        }
    });

    connector.platform.on("resume", scheduleCheckLogin);
    connector.platform.on("windowFocus", scheduleCheckLogin);
    this.bus.on("changeStatus", scheduleCheckLogin);
};

MSStartSocial.prototype = Object.create(Social.prototype);
MSStartSocial.prototype.constructor = MSStartSocial;

MSStartSocial.prototype.isShareSupported = function () {
    return true;
};

MSStartSocial.prototype._connect = function (callback) {
    this.loadPlayer((player) => {
        if (player) {
            this.setPlayer(player);
        }

        callback(connector.STATUS_CONNECTED);
    });
};

MSStartSocial.prototype._checkLogin = function () {
    if (!this.isConnected() || this.isLoggedIn() || this.loginRunning || this.checkLoginRunning) {
        return;
    }

    this.checkLoginRunning = true;

    this.loadPlayer((player) => {
        this.checkLoginRunning = false;

        if (!player || !this.isConnected() || this.isLoggedIn() || this.loginRunning) {
            return;
        }

        this.setPlayer(player);
        this.onLogin();
    });
};

MSStartSocial.prototype.loadPlayer = function (callback) {
    $msstart.getSignedInUserAsync()
        .then((player) => {
            console.log("MSStart getSignedInUserAsync", player);
            callback(player);
        })
        .catch((error) => {
            console.log("MSStart getSignedInUserAsync error", error);
            callback();
        });
};

MSStartSocial.prototype.setPlayer = function (player) {
    this.playerId = player.publisherPlayerId || player.playerId;
    this.publisherPlayerId = player.publisherPlayerId;
    this.player = player;
};

MSStartSocial.prototype.isLoggedIn = function () {
    return !!this.playerId;
};

MSStartSocial.prototype._getUserID = function () {
    return this.playerId;
};

MSStartSocial.prototype._login = function (callback) {
    this.loginRunning = true;

    $msstart.signInAsync().then((player) => {
        this.setPlayer(player);
        console.log("MSStart login", player);
    }).catch((error) => {
        console.log("MSStart login error", error);
    }).finally(() => {
        this.loginRunning = false;

        callback();
    });
};

MSStartSocial.prototype.share = function (data, callback) {
    console.log("MS Start share", data);

    $msstart.shareAsync({
        title: data.title,
        text: data.text,
        image: data.image
    }).then(() => {
        console.log("MSStart share: success!");
        callback(connector.CODE_SUCCEED);
    }).catch((error) => {
        console.log("MSStart share error", error);
        callback(connector.CODE_FAILED);
    });
};

MSStartSocial.prototype._aboutMe = function (callback) {
    const id = this.playerId || connector.platform.getUserID();
    const name = this.player && this.player.playerDisplayName || `MSN Player ${(`${id}`).substring(0, 18)}`;

    callback(connector.CODE_SUCCEED, { id, name });
};

MSStartSocial.prototype.getAccessToken = function () {
    return "msstart";
};
